module.exports = __webpack_public_path__ + "static/img/trash.f716872.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map/trash.png
// module id = fjAd
// module chunks = 1